<template>
  <div class="card has-padding-20 has-padding-left-0">
    <validation-observer
      ref="additionalInfoAndDocsObserver"
      tag="div"
      v-slot="{invalid, valid, untouched, errors}"
    >
      <div class="card-content">
        <div class="has-margin-bottom-40 has-margin-top-10 has-border-bottom">
          <h2
            class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
          >additional information</h2>
        </div>
        <div class="columns is-multiline">
          <!-- Additional Handling Information -->
          <div class="column is-12">
            <input-with-validation
              :type="'textarea'"
              :rules="''"
              :model="additionalInfoAndDocs.additional_handling_information"
              :vuexKey="'additional_handling_information'"
              :label="'Additional Shipping Information (Optional)'"
              :errorLabel="`Additional Shipping Information`"
              :name="'additionalShippingInformation'"
              :placeholder="'Additional Shipping Information'"
              @input="updateVuex"
            ></input-with-validation>
          </div>
        </div>

        <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
          <h2
            class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
          >additional Documentation</h2>
        </div>

        <button class="button has-margin-bottom-10 is-primary" @click="showAddDocumentModal = true">
          <b-icon icon="plus" class="has-margin-right-10"></b-icon>Add New Document
          <span>(max. file size of 1mb)</span>
        </button>

        <uploaded-documents :documents="uploadedDocuments"></uploaded-documents>

        <b-modal :active.sync="showAddDocumentModal">
          <template v-for="(document, index) in certificateDocuments">
            <add-certificate-document :key="index" :certificate_document="document"></add-certificate-document>
          </template>
        </b-modal>

        <!-- Form Buttons -->
        <div class="steps-actions has-margin-top-30">
          <div class="steps-action">
            <a href="#" class="button is-danger" @click="previous">Previous</a>
          </div>
          <div class="steps-action">
            <a href="#" class="button is-success" @click="save">Save</a>
          </div>
          <div class="steps-action">
            <button class="button is-primary" @click="next">Next</button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "./form-inputs/InputWithValidation";
import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
import AddCertificateDocument from "./AddCertificateDocument";
import UploadedDocuments from "./UploadedDocuments";
const { mapMutations } = createNamespacedHelpers("shippers");

export default {
  name: "AdditionalInfoAndDocs",

  components: {
    ValidationObserver,
    InputWithValidation,
    AddCertificateDocument,
    UploadedDocuments
  },

  props: {
    additionalInfoAndDocs: { type: Object, required: true },
    moveToNext: { type: Function },
    moveToPrevious: { type: Function },
    saveShippingRequest: { type: Function },
    certificateDocuments: { type: Array, required: true },
    uploadedDocuments: { type: Array, required: true }
  },

  data() {
    return {
      showAddDocumentModal: false
    };
  },

  methods: {
    ...mapMutations({
      commitAdditionalInfoAndDocsState:
        SHIPPER_MUTATION_TYPES.UPDATE_ADDITIONAL_INFO_AND_DOCS
    }),

    /**
     * Update the additional details in the vuex store
     */
    updateVuex({ key, value }) {
      this.commitAdditionalInfoAndDocsState({ key, value });
    },

    /**
     * Move to the previous step in the ShippingRequest form.
     */
    previous() {
      this.moveToPrevious();
    },

    /**
     * Validate the ShipperConsigneeDetails form before moving to the next step in the ShippingRequest process.
     */
    async next() {
      const isValid = await this.$refs.additionalInfoAndDocsObserver.validate();
      if (!isValid) {
        return;
      }
      this.moveToNext();
    },

    async save() {
      const isValid = await this.$refs.additionalInfoAndDocsObserver.validate();
      if (!isValid) {
        return;
      }
      this.saveShippingRequest();
    }
  }
};
</script>


<style lang="scss">
button {
  span {
    font-size: 0.8em;
    padding-left: 10px;
  }
}
</style>